import React from 'react';
import { Table } from 'react-bootstrap';

const MarkingCorrectionHistoryChangesTable = ({ changes }) => {
  const renderChange = (change, index) => (
    <tr key={index}>
      <td className="text-center align-middle">{change.date}</td>
      <td className="text-center align-middle">{change.change_type}</td>
      <td className="text-center align-middle">{change.marking_type}</td>
      <td className="text-center align-middle">{change.marking_time}</td>
      <td className="text-center align-middle">{change.original_value}</td>
      <td className="text-center align-middle">{change.modified_value}</td>
      <td className="text-center align-middle">{change.reason}</td>
      <td className="text-center align-middle">{change.correction_date}</td>
    </tr>
  );

  return (
    <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
      <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
        <tr className="rdt_TableCol">
          <th className="text-center align-middle">FECHA</th>
          <th className="text-center align-middle">TIPO DE CAMBIO</th>
          <th className="text-center align-middle">TIPO DE MARCACIÓN</th>
          <th className="text-center align-middle">HORA DE MARCACIÓN</th>
          <th className="text-center align-middle">VALOR ORIGINAL</th>
          <th className="text-center align-middle">VALOR MODIFICADO</th>
          <th className="text-center align-middle">MOTIVO</th>
          <th className="text-center align-middle">FECHA DE CORRECCIÓN</th>
        </tr>
      </thead>
      <tbody>{changes && changes.map((change, index) => renderChange(change, index))}</tbody>
    </Table>
  );
};

export default MarkingCorrectionHistoryChangesTable;
